const environment = process.env.REACT_APP_REMOTE_ENV || "DEV";

export default environment;
